// extracted by mini-css-extract-plugin
export default {"social":"hByNICkR","mobile":"WVrvbYZh","comments":"fqGzhqGM","commentsTitle":"dA73eupA","commentsCount":"SX6KvLcf","rambler-share":"rambler-share"};